<template>
<b-container>
    <b-row class="text-left">
      <b-col></b-col>
      <b-col cols="10" class="mb-3 mt-3">
        <h3>Organizations</h3>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row>
      <b-col>
        <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      </b-col>
    </b-row>
    <LoadingIndicator 
      v-if="loading"
      topic="Organizations"
    />
    <div v-if="!loading">
      <b-row class="text-left">
        <b-col></b-col>
        <b-col cols="5" class="mb-3">
          <b-form-input type="text" placeholder="Enter search text" v-model="searchFilter"></b-form-input>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row class="text-left">
        <b-col></b-col>
        <b-col cols="10">
          <b-table 
            striped
            hover
            :items="organizations"
            :fields="fields"
            :filter="searchFilter">
            <template v-slot:cell(view_org)="data">
              <b-button-group class="float-left">
                <b-button size="sm" :to="'/organization/' + data.item.organizationId" class="float-left">View</b-button>
              </b-button-group>
            </template>
          </b-table>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";

export default {
  name: "OrganizationList",
  components: {
  },
  data() {
    return {
      loading: false,
      searchFilter: null,
      organizations: [],
      errors: [],
      fields: [
        { key: "view_org", label: "", class: "nowrap xs" },
        { key: "name", label: "Name", sortable: true },
      ]
    };
  },
  mounted() {
    if (!this.isSystemAdmin) {
      this.defaultRedirect();
    }
    this.getOrganizationList();
  },
  methods: {
    getOrganizationList() {
      this.loading = true;
      axios
        .get(`${this.$api_url}/organizations`, this.getReqConfig())
        .then(response => {
          this.organizations = response.data;
          this.showList = true;
          this.organizations.sort((a, b) => a.name < b.name ? -1 : 1)
        })
        .catch(err => {
          this.errors.push(err);
        })
        .finally(() =>{
          this.loading = false;
        });
    }
  },
  computed: {

  }
}
</script>
<style scoped>
.nowrap {
  display: flex;
  white-space: nowrap;
}
</style>